module.exports = __webpack_public_path__ + "img/extended.54ce77f6.png";